"use client";

import React, { useEffect, useRef, useState } from "react";
import Image from "next/image";
import Link from "next/link";
import '../app/homepage.css';
import Testimonials from "./Testimonials";
import StatsSection from "./StatusSection";
import GlobalPartnersCount from "@/components/GlobalPartnersCount";
import { m, Variants } from "framer-motion"; // Import framer-motion
import { useInView } from "react-intersection-observer"; // Import react-intersection-observer
import { ReviewStar as Icon_ReviewStar } from "@/components/customer/icons/ReviewStar";
const SvgIcons = { ReviewStar: Icon_ReviewStar };
import TestiReviewCommonImages from "./otherpages/TestiReviewCommonImages";
import GoogleImg from '../images/G_image.webp';
import FaqSection from "./Homepagefaq";
import { getImageUrl } from "@/lib/imageUrl";
import TrustedPartners from "./TrustedPartners";
import CircularTestimonialView from "./CircularTestimonialView";




const Icons = {
  Rocket: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <g clipPath="url(#clip0_2576_2640)">
        <path d="M10.1749 10.8021L6.70942 11.0699C5.74513 11.1444 4.88631 11.6498 4.35303 12.4564L0.356423 18.501C-0.048027 19.1128 -0.112323 19.8783 0.184315 20.5489C0.481031 21.2195 1.09079 21.6869 1.8154 21.7991L4.98842 22.2906C5.73068 18.3515 7.50754 14.4222 10.1749 10.8021Z" fill="#63BADD" />
        <path d="M17.709 35.0115L18.2005 38.1845C18.3127 38.9091 18.7801 39.5189 19.4506 39.8155C19.7296 39.939 20.0249 39.9999 20.3187 39.9999C20.7315 39.9999 21.1413 39.8797 21.4986 39.6434L27.5434 35.6469C28.35 35.1135 28.8554 34.2546 28.9298 33.2905L29.1975 29.8251C25.5774 32.4925 21.6481 34.2693 17.709 35.0115Z" fill="#63BADD" />
        <path d="M16.5158 32.8123C16.6259 32.8123 16.7367 32.8032 16.8473 32.7848C18.4976 32.5089 20.0882 32.044 21.6055 31.4356L8.56421 18.3943C7.95578 19.9115 7.49094 21.5022 7.215 23.1525C7.10625 23.8031 7.32445 24.4658 7.79078 24.9322L15.0676 32.209C15.4548 32.5961 15.9774 32.8123 16.5158 32.8123Z" fill="#63BADD" />
        <path d="M36.8096 17.7345C40.0009 11.5647 40.1191 5.04473 39.9523 1.98694C39.8952 0.939211 39.0598 0.103905 38.012 0.0467965C37.5142 0.0196092 36.9241 0 36.259 0C32.8398 0 27.4296 0.517887 22.2645 3.18951C18.1597 5.31269 12.7772 9.98773 9.60156 16.1316C9.63906 16.1609 9.6757 16.192 9.71023 16.2265L23.7726 30.2889C23.8072 30.3234 23.8382 30.36 23.8675 30.3975C30.0113 27.2218 34.6864 21.8393 36.8096 17.7345ZM23.2565 8.45618C25.541 6.17175 29.2582 6.17151 31.5428 8.45618C32.6495 9.56281 33.259 11.0343 33.259 12.5994C33.259 14.1644 32.6495 15.6359 31.5428 16.7425C30.4007 17.8846 28.8999 18.4558 27.3997 18.4559C25.899 18.456 24.3989 17.8849 23.2565 16.7425C22.1498 15.6359 21.5403 14.1644 21.5403 12.5994C21.5403 11.0343 22.1498 9.56281 23.2565 8.45618Z" fill="#63BADD" />
        <path d="M24.9145 15.0853C26.2852 16.456 28.5156 16.4561 29.8863 15.0853C30.5503 14.4212 30.916 13.5384 30.916 12.5994C30.916 11.6603 30.5503 10.7775 29.8863 10.1135C29.201 9.42811 28.3007 9.08545 27.4004 9.08545C26.5002 9.08545 25.5998 9.42811 24.9145 10.1135C24.2505 10.7775 23.8848 11.6603 23.8848 12.5994C23.8848 13.5384 24.2505 14.4213 24.9145 15.0853Z" fill="#63BADD" />
        <path d="M1.19535 32.9637C1.49527 32.9637 1.7952 32.8494 2.02395 32.6205L5.84996 28.7945C6.30762 28.3368 6.30762 27.5948 5.84996 27.1372C5.39238 26.6795 4.65035 26.6795 4.1927 27.1372L0.36668 30.9632C-0.0909766 31.4209 -0.0909766 32.1628 0.36668 32.6205C0.595508 32.8493 0.89543 32.9637 1.19535 32.9637Z" fill="#63BADD" />
        <path d="M9.35637 30.6434C8.89879 30.1858 8.15676 30.1858 7.6991 30.6434L0.343242 37.9993C-0.114414 38.4569 -0.114414 39.1989 0.343242 39.6565C0.57207 39.8854 0.871992 39.9997 1.17191 39.9997C1.47184 39.9997 1.77176 39.8854 2.00051 39.6565L9.35629 32.3007C9.81402 31.843 9.81402 31.1011 9.35637 30.6434Z" fill="#63BADD" />
        <path d="M11.2063 34.1498L7.38035 37.9758C6.9227 38.4334 6.9227 39.1754 7.38035 39.633C7.60918 39.8619 7.9091 39.9763 8.20895 39.9763C8.50879 39.9763 8.80879 39.8619 9.03754 39.633L12.8636 35.807C13.3212 35.3494 13.3212 34.6074 12.8636 34.1498C12.406 33.6921 11.6639 33.6921 11.2063 34.1498Z" fill="#63BADD" />
      </g>
      <defs>
        <clipPath id="clip0_2576_2640">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  Services: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path d="M14.0257 25.95C12.084 27.475 10.834 29.8417 10.834 32.5V35H5.83398C4.45065 35 3.33398 33.8833 3.33398 32.5V30.8333C3.33398 27.6083 5.94232 25 9.16732 25H10.834C12.0173 25 13.109 25.35 14.0257 25.95Z" fill="#63BADD" />
      <path d="M30 25C32.0711 25 33.75 23.3211 33.75 21.25C33.75 19.1789 32.0711 17.5 30 17.5C27.9289 17.5 26.25 19.1789 26.25 21.25C26.25 23.3211 27.9289 25 30 25Z" fill="#63BADD" />
      <path d="M10 25C12.0711 25 13.75 23.3211 13.75 21.25C13.75 19.1789 12.0711 17.5 10 17.5C7.92893 17.5 6.25 19.1789 6.25 21.25C6.25 23.3211 7.92893 25 10 25Z" fill="#63BADD" />
      <path d="M36.6663 30.8333V32.5C36.6663 33.8833 35.5496 35 34.1663 35H29.1663V32.5C29.1663 29.8417 27.9163 27.475 25.9746 25.95C26.8913 25.35 27.9829 25 29.1663 25H30.8329C34.0579 25 36.6663 27.6083 36.6663 30.8333Z" fill="#63BADD" />
      <path d="M19.9993 25.8333C22.5307 25.8333 24.5827 23.7813 24.5827 21.25C24.5827 18.7187 22.5307 16.6666 19.9993 16.6666C17.468 16.6666 15.416 18.7187 15.416 21.25C15.416 23.7813 17.468 25.8333 19.9993 25.8333Z" fill="#63BADD" />
      <path d="M20.8333 25.8334H19.1667C15.4908 25.8334 12.5 28.8242 12.5 32.5V35C12.5 36.3784 13.6217 37.5 15 37.5H25C26.3783 37.5 27.5 36.3784 27.5 35V32.5C27.5 28.8242 24.5092 25.8334 20.8333 25.8334Z" fill="#63BADD" />
      <path d="M32.0835 13.9033L30.0726 14.6183C29.5018 14.8208 28.906 14.3883 28.9226 13.7825L28.981 11.6492L27.6793 9.9575C27.3101 9.4775 27.5376 8.77666 28.1185 8.605L30.166 8.00166L31.3726 6.24083C31.7151 5.74166 32.4518 5.74166 32.7943 6.24083L34.001 8.00166L36.0485 8.605C36.6293 8.77583 36.8568 9.4775 36.4876 9.9575L35.186 11.6492L35.2443 13.7825C35.261 14.3875 34.6643 14.8208 34.0943 14.6183L32.0835 13.9033Z" fill="#63BADD" />
      <path d="M7.91744 13.9033L5.90661 14.6183C5.33578 14.8208 4.73994 14.3883 4.75661 13.7825L4.81494 11.6492L3.51328 9.9575C3.14411 9.4775 3.37161 8.77666 3.95244 8.605L5.99994 8.00166L7.20661 6.24083C7.54911 5.74166 8.28578 5.74166 8.62828 6.24083L9.83494 8.00166L11.8824 8.605C12.4633 8.77583 12.6908 9.4775 12.3216 9.9575L11.0199 11.6492L11.0783 13.7825C11.0949 14.3875 10.4983 14.8208 9.92828 14.6183L7.91744 13.9033Z" fill="#63BADD" />
      <path d="M20.0005 12.0284L17.6163 12.8759C16.9396 13.1167 16.233 12.6026 16.253 11.8851L16.3221 9.3559L14.7788 7.35006C14.3413 6.7809 14.6113 5.95007 15.2996 5.74673L17.7271 5.0309L19.158 2.9434C19.5638 2.3509 20.438 2.3509 20.8438 2.9434L22.2746 5.0309L24.7021 5.74673C25.3905 5.95007 25.6605 6.7809 25.223 7.35006L23.6796 9.3559L23.7488 11.8851C23.7688 12.6026 23.0613 13.1167 22.3855 12.8759L20.0005 12.0284Z" fill="#63BADD" />
    </svg>
  ),

  Brand: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <g clipPath="url(#clip0_2576_2667)">
        <path d="M36.0299 25.0798C35.2188 24.612 34.2733 24.4872 33.3624 24.7298C32.85 24.8665 32.4063 25.1341 32.0144 25.468L29.7167 24.1417C30.285 22.8472 30.6112 21.4238 30.6112 19.922C30.6112 18.4203 30.285 16.9969 29.7167 15.7024L32.0144 14.3761C32.4063 14.7099 32.8503 14.9776 33.3624 15.1143C33.6657 15.1958 33.9724 15.2357 34.2779 15.2357C34.8867 15.2357 35.4888 15.0768 36.0299 14.7643C37.7078 13.795 38.2858 11.6411 37.3175 9.96108C36.3458 8.28353 34.1943 7.7043 32.5155 8.67385H32.5131C31.1929 9.4374 30.5688 10.9334 30.8291 12.354L28.5232 13.6848C26.8224 11.3853 24.2211 9.82955 21.2362 9.49385V6.7375C22.5973 6.25197 23.58 4.96351 23.58 3.43763C23.58 1.49915 22.0031 -0.0780029 20.0643 -0.0780029C18.1258 -0.0780029 16.5487 1.49915 16.5487 3.43763C16.5487 4.96351 17.5314 6.25197 18.8924 6.7375V9.49355C15.9075 9.82924 13.3062 11.3853 11.6054 13.6845L9.29983 12.3537C9.55984 10.9331 8.93575 9.43709 7.61556 8.67354H7.61312C5.93556 7.70552 3.78163 8.28322 2.81117 9.9623C1.84315 11.6411 2.42085 13.7947 4.09871 14.7643C4.64009 15.0764 5.24068 15.2357 5.85073 15.2357C6.15499 15.2357 6.46291 15.1955 6.76626 15.1143C7.27865 14.9776 7.72237 14.7099 8.11422 14.3761L10.4119 15.7024C9.84365 16.9969 9.51742 18.4203 9.51742 19.922C9.51742 21.4238 9.84365 22.8472 10.4119 24.1417L8.11422 25.468C7.72237 25.1341 7.27834 24.8665 6.76626 24.7298C5.85897 24.4872 4.91139 24.6108 4.09871 25.0798C2.42085 26.0494 1.84315 28.203 2.81117 29.883C3.46242 31.0091 4.64558 31.6396 5.86232 31.6396C6.45833 31.6396 7.06258 31.4885 7.61556 31.1705C8.93575 30.4067 9.55984 28.9107 9.29952 27.4901L11.6054 26.1592C13.3062 28.4587 15.9075 30.0148 18.8924 30.3505V33.1066C17.5314 33.5921 16.5487 34.8806 16.5487 36.4064C16.5487 38.3449 18.1258 39.9221 20.0643 39.9221C22.0031 39.9221 23.58 38.3449 23.58 36.4064C23.58 34.8806 22.5973 33.5921 21.2362 33.1066V30.3505C24.2211 30.0148 26.8228 28.4587 28.5232 26.1592L30.8291 27.4901C30.5688 28.911 31.1935 30.4067 32.5155 31.1705C33.0673 31.4885 33.6703 31.6396 34.2654 31.6396C35.4818 31.6396 36.6662 31.0091 37.3175 29.8818C38.2858 28.203 37.7078 26.0494 36.0299 25.0798ZM16.5487 14.0627H23.58V16.4064H16.5487V14.0627ZM23.58 25.7814H16.5487V23.4377H23.58V25.7814ZM24.7518 21.0939H15.3768V18.7502H24.7518V21.0939Z" fill="#63BADD" />
      </g>
      <defs>
        <clipPath id="clip0_2576_2667">
          <rect width="40" height="40" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  Achieve: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" viewBox="0 0 40 40" fill="none">
      <path d="M36.2242 36.4681L32.0002 27.1601L27.4202 16.9561C27.389 16.8923 27.3455 16.8352 27.2922 16.7881L24.4442 13.5881C24.389 13.5333 24.3173 13.498 24.2401 13.4878C24.1629 13.4775 24.0845 13.4929 24.0169 13.5315C23.9493 13.57 23.8961 13.6297 23.8657 13.7014C23.8352 13.773 23.8291 13.8527 23.8482 13.9281L27.6322 27.1601C27.677 27.246 27.6892 27.3453 27.6664 27.4394C27.6436 27.5336 27.5874 27.6163 27.5082 27.6721L22.8722 32.4321C22.7705 32.529 22.7031 32.6563 22.68 32.7948C22.6569 32.9333 22.6794 33.0755 22.7442 33.2001L24.8682 37.6001C24.9255 37.721 25.0162 37.8229 25.1297 37.8938C25.2431 37.9647 25.3744 38.0016 25.5082 38.0001H37.4562C37.6026 38.0001 37.743 37.942 37.8465 37.8385C37.95 37.7349 38.0082 37.5945 38.0082 37.4481C38.0082 37.3017 37.95 37.1613 37.8465 37.0578C37.743 36.9543 37.6026 36.8961 37.4562 36.8961H36.8642C36.726 36.9014 36.5897 36.8628 36.4748 36.7859C36.3599 36.709 36.2721 36.5978 36.2242 36.4681ZM23.0842 15.2001L26.4002 26.7761C26.4332 26.8944 26.435 27.0191 26.4056 27.1382C26.3762 27.2574 26.3164 27.3669 26.2322 27.4561L21.5082 32.2561C21.4276 32.3392 21.373 32.444 21.3509 32.5577C21.3289 32.6713 21.3405 32.7889 21.3842 32.8961L23.3842 36.9761C23.4349 37.0849 23.4576 37.2046 23.4502 37.3243C23.4429 37.4441 23.4057 37.5601 23.3421 37.6618C23.2785 37.7636 23.1905 37.8478 23.0861 37.9069C22.9817 37.966 22.8641 37.998 22.7442 38.0001H2.54419C2.39779 38.0001 2.25738 37.942 2.15386 37.8385C2.05034 37.7349 1.99219 37.5945 1.99219 37.4481C1.99219 37.3017 2.05034 37.1613 2.15386 37.0578C2.25738 36.9543 2.39779 36.8961 2.54419 36.8961H3.94419C4.02571 36.8925 4.10285 36.8582 4.16019 36.8001L9.81619 31.4961C9.87033 31.4447 9.91321 31.3826 9.94212 31.3138C9.97104 31.2449 9.98536 31.1708 9.98419 31.0961L11.1842 24.1681C11.1812 24.0887 11.1993 24.0099 11.2365 23.9397C11.2737 23.8695 11.3288 23.8103 11.3962 23.7681L13.9482 21.5161C14.0247 21.4463 14.1161 21.3946 14.2154 21.365C14.3147 21.3354 14.4194 21.3286 14.5217 21.3452C14.624 21.3617 14.7213 21.4011 14.8062 21.4605C14.8911 21.5199 14.9615 21.5977 15.0122 21.6881L19.7682 29.8801C19.8414 30.0037 19.9607 30.0932 20.0998 30.1288C20.239 30.1644 20.3866 30.1433 20.5102 30.0701C20.6338 29.9969 20.7232 29.8776 20.7589 29.7385C20.7945 29.5993 20.7734 29.4517 20.7002 29.3281L16.7482 22.5681C16.685 22.4587 16.6517 22.3345 16.6517 22.2081C16.6517 22.0818 16.685 21.9576 16.7482 21.8481L21.8482 13.3001C21.9288 13.205 21.9741 13.0849 21.9762 12.9601V2.56014C21.9775 2.4693 22.0008 2.38013 22.0443 2.30033C22.0877 2.22054 22.1499 2.1525 22.2255 2.10211C22.3011 2.05171 22.3878 2.02047 22.4782 2.01106C22.5685 2.00166 22.6598 2.01439 22.7442 2.04814L29.6322 5.02414C29.7276 5.07091 29.8079 5.14349 29.8641 5.23364C29.9203 5.3238 29.9501 5.4279 29.9501 5.53414C29.9501 5.64038 29.9203 5.74449 29.8641 5.83464C29.8079 5.92479 29.7276 5.99737 29.6322 6.04414L23.4682 8.66814C23.3461 8.72568 23.2419 8.81518 23.1665 8.92714C23.0912 9.03911 23.0475 9.16938 23.0402 9.30414V15.0441C23.0402 15.0881 23.0842 15.1721 23.0842 15.2161V15.2001Z" fill="#63BADD" />
    </svg>
  ),

  Org: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
      <path d="M70.3371 68.0241C69.1709 66.2361 67.203 64.8693 65.7202 63.3219C64.4754 62.1966 62.4179 59.5128 61.0552 61.9825C61.1667 60.7405 58.8059 59.6585 57.971 58.8587C67.5584 48.2293 61.1758 30.9323 46.8418 29.4421C50.0685 26.1053 52.425 22.0374 55.2016 18.3312C56.0344 19.2333 57.5763 22.2534 58.6048 22.4157C60.4355 22.5325 59.7912 19.1541 60.1653 17.9341C60.3974 15.4902 60.6563 13.0547 60.9094 10.6113C61.0645 9.11438 61.6202 6.79518 59.1424 7.61742C54.9771 8.85742 50.3195 10.308 46.1483 11.616C45.0933 11.9123 45.0413 13.5462 46.1146 13.8821C47.0861 14.2155 49.3291 15.024 50.2675 15.352C46.9867 18.8696 43.7483 22.4238 40.4728 25.9467C39.0253 25.1205 36.429 23.7889 34.9509 22.943C34.084 22.5723 32.9262 21.3597 32.095 22.3915C24.7347 32.1997 17.2837 42.7222 9.68272 52.3254L9.80016 52.4262C8.97424 53.2822 10.3706 54.4941 11.0989 53.5422L11.2171 53.6438C18.5389 45.5534 26.5586 37.8326 33.6714 29.5265C34.6139 30.084 35.6302 30.8622 36.5629 31.2667C36.425 31.1225 36.1466 30.9622 36.0518 30.8281C36.3019 30.8709 36.5672 31.052 36.1915 30.7349C36.5968 30.9793 36.9946 31.2569 37.4054 31.475C36.0102 32.3323 34.4558 33.3304 33.5027 34.6256C33.6166 34.5688 33.7566 34.4033 33.8814 34.3758C33.8502 34.5429 33.6506 34.7121 33.9538 34.5197C33.725 34.7627 33.459 35.0105 33.2843 35.2846C54.1363 18.6859 73.7904 53.0576 48.7406 61.9385C33.2216 66.0009 22.9616 46.7453 33.137 35.1371C15.064 49.7443 39.9147 75.5993 56.7285 60.0929C57.513 61.152 58.3606 62.2075 59.4746 62.9289C59.5261 62.9249 59.5986 62.899 59.6082 62.9389C59.64 62.9269 59.6642 62.9345 59.6731 62.9509C59.683 62.975 59.7523 62.9366 59.7741 62.9483C59.8587 62.987 59.8998 63.0605 60.0083 63.0523C60.0858 63.0451 60.0973 63.1067 60.1542 63.1333C60.2318 63.1086 60.3443 63.0539 60.3872 63.0811C60.3102 63.2408 60.1085 63.4286 60.1466 63.6075C60.1998 63.6107 60.2219 63.5507 60.2814 63.5705C60.3162 63.6291 60.289 63.7341 60.384 63.6889C60.3418 63.7833 60.2611 63.8443 60.2594 63.9574C60.8171 64.0881 62.2053 62.0886 62.4797 62.5621C64.2531 64.5862 66.3605 66.6165 68.1846 68.691C67.7024 69.1928 67.1381 69.7326 66.6422 70.2302C64.6992 68.2355 62.6746 66.2797 60.4434 64.648C60.3893 64.4925 60.1478 64.439 60.1682 64.2632C60.1923 64.2029 60.0627 64.1048 60.1125 64.0443C60.1339 63.967 60.0654 63.8888 60.1118 63.8101C56.6291 64.5691 64.1003 70.7435 65.0667 71.9317C66.7747 73.4664 68.1904 72.0397 69.347 70.6885C70.079 70.0102 70.7181 69.0909 70.3371 68.0241ZM43.4066 29.4737C41.3115 29.7382 39.2773 30.4203 37.4435 31.4544C36.3803 30.4814 35.2 29.6078 33.9858 28.8101C33.5114 28.4912 33.1256 28.9614 32.8227 29.2883C28.6659 33.2957 24.6413 37.4448 20.4622 41.4427C24.6226 35.959 29.1544 30.0824 33.2661 24.5582C43.0562 29.3441 38.8742 30.5792 46.5349 22.7568C47.931 21.2645 51.0184 17.9669 52.3733 16.4853C55.1939 13.9307 52.0909 13.6163 50.0968 12.827C52.5224 12.0768 56.277 10.8853 58.6643 10.1649C58.3605 13.0256 58.1653 15.8953 57.9197 18.7605C55.3957 15.8065 55.5211 14.0707 53.0934 18.3912C50.8717 22.0398 48.5259 25.5875 46.6341 29.4192C45.5624 29.3219 44.4667 29.3289 43.4066 29.4737ZM66.7059 70.2931L66.6693 70.2569C66.6906 70.2585 66.7053 70.2859 66.7163 70.3017C66.7179 70.3025 66.7195 70.3032 66.7203 70.3046C66.7192 70.3038 66.7288 70.3163 66.7059 70.2931ZM68.2504 68.7664C68.247 68.7617 68.2426 68.7568 68.2406 68.7509C68.2474 68.7589 68.2696 68.7792 68.2504 68.7664ZM68.2706 68.6017C68.259 68.6142 68.2322 68.643 68.2203 68.6557C68.2043 68.6256 68.3099 68.5635 68.2706 68.6017ZM33.2403 45.227C33.517 42.6251 34.7653 40.2923 36.1298 38.1302C29.0557 41.9841 30.295 53.0261 36.1725 57.4929C55.704 71.0926 69.3419 36.6435 45.5949 33.5913C45.1682 33.1038 44.4166 33.156 44.0206 33.6541C41.1461 34.0267 38.145 35.4485 36.3813 37.7272C36.4738 37.6915 36.5738 37.563 36.6755 37.5541C36.6698 37.6893 36.5302 37.8246 36.7558 37.691C36.5915 37.879 36.3909 38.0606 36.2771 38.2776C38.2411 37.0089 40.1877 35.5923 42.596 35.3309C40.5214 38.4425 39.5203 42.223 39.4664 45.9427C37.3637 46.0539 35.2306 45.9349 33.2133 46.6638C33.2331 46.1793 33.156 45.7088 33.2403 45.227ZM46.533 55.8808C46.1717 56.6904 45.6782 57.424 45.2594 58.1998C45.0474 58.2086 44.8352 58.2142 44.6229 58.2145C42.3014 55.3926 41.5606 51.5525 41.3558 47.9539C43.637 48.0902 45.9128 48.0104 48.1946 47.9849C48.0018 50.6742 47.7126 53.427 46.533 55.8808ZM55.8798 49.5038C54.8029 53.8321 51.148 57.3921 46.6942 58.0497C49.363 55.427 50.2587 51.5885 50.5003 47.9677C52.4398 48.0795 54.2994 47.7035 56.2078 47.5392C56.1554 48.2033 56.0456 48.8614 55.8798 49.5038ZM50.7176 36.9016C53.9694 38.8553 56.151 42.4504 56.2331 46.2589C54.4136 45.5715 52.4384 45.7355 50.5267 45.6358C50.3642 42.0675 49.384 38.4675 47.2912 35.5331C48.5003 35.792 49.6626 36.259 50.7176 36.9016ZM41.408 45.3373C41.6579 42.0083 42.7403 38.6328 44.8677 36.0229C47.0429 38.7262 48.0021 42.2449 48.1933 45.6686C45.9147 45.7552 43.6462 45.8729 41.3693 45.9072C41.3682 45.8901 41.4056 45.3707 41.408 45.3373ZM33.3933 47.5523C35.3808 47.7118 37.4488 47.8872 39.5018 47.8734C39.7056 51.6097 40.76 55.495 43.5365 58.1587C38.0643 57.6461 33.8304 52.8502 33.2658 47.5035C33.313 47.5123 33.3608 47.4992 33.3933 47.5523Z" fill="white" />
    </svg>
  ),
  Lead: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
      <path fillRule="evenodd" clipRule="evenodd" d="M22.1751 40.0568C21.1112 40.0445 18.6957 40.0789 17.6602 40.0691C16.6256 39.9867 14.8407 40.5669 14.4093 39.2578C13.6068 34.735 14.1983 29 19.0783 27.0818C17.0634 24.9251 17.6952 20.7906 20.6727 19.9282C20.9039 19.8954 21.1253 19.6083 21.3546 19.6827C21.7364 19.7411 22.197 19.4426 22.5159 19.8182C22.445 19.9016 22.3608 19.8918 22.2759 19.9352C22.3636 19.967 22.2829 20.0334 22.2759 20.0973C22.4956 20.215 22.2999 20.2416 22.1775 20.3162C20.9533 20.8918 19.9612 22.2189 19.8293 23.5555C19.7364 25.2085 21.2644 26.6947 22.9172 26.2661C24.2884 26.0171 25.121 24.4165 24.7898 23.1136C24.4652 21.8192 23.2188 21.0656 22.516 20.0338C22.5744 20.0027 22.633 19.9894 22.6736 19.9125C22.733 19.8709 22.8109 19.9187 22.8668 19.8346C23.0378 19.7106 23.261 19.815 23.4655 19.6928C27.1277 19.9986 28.4679 24.6754 25.9165 27.1688C28.2984 28.1174 30.8327 31.9768 30.0549 34.503C29.9637 34.3622 29.9725 34.1984 29.9256 34.0406C29.892 34.209 29.853 34.0672 29.7636 34.0336C29.7069 34.0832 29.7405 34.1744 29.7016 34.233C29.0346 31.7626 27.1682 29.5267 24.6943 28.633C23.5808 28.1653 22.3788 28.9315 21.222 28.4717C16.649 29.6096 16.1912 33.6789 16.545 37.6981C20.6045 37.6112 24.7519 37.644 28.8052 37.8389C28.9658 36.6683 29.09 35.4442 29.8389 34.503C30.2303 35.5637 31.253 39.9603 29.2367 39.7426C26.8989 40.0187 24.5392 40.0904 22.1751 40.0568ZM17.7647 13.9765C17.8615 13.4968 17.9983 13.0021 18.0269 12.5176C17.9861 12.4893 18.0792 12.4786 18.1111 12.4573C18.1447 12.4147 18.1482 12.2683 18.2626 12.18C18.3236 12.133 18.1482 12.0661 18.2741 12.0533C18.3325 12.0462 18.3317 12.0232 18.344 11.9877C18.2498 11.917 18.5797 11.7918 18.6744 11.8955C19.1516 11.8426 19.8388 12.3066 19.8463 12.8211C20.0063 14.2667 21.0836 16.4266 18.7852 16.569C18.7311 16.545 18.5557 16.5141 18.4938 16.475C18.4938 16.4219 18.2484 16.4227 18.2847 16.3147C18.2989 16.2616 18.1677 16.2128 18.1828 16.1624C18.1986 16.0866 18.0388 15.957 18.0367 15.956C17.6588 15.4891 17.9052 14.5851 17.7647 13.9765ZM14.2703 22.8627C14.9399 20.9582 14.4757 18.797 14.3474 16.8341C14.2376 15.1789 14.5144 13.1982 13.2685 11.9206C13.2012 12.0269 13.1082 11.9082 13.0348 11.9667C12.9949 11.9189 13.0047 11.88 12.9293 11.849C12.537 12.0093 12.8088 12.1954 12.6335 12.3707C12.5272 12.4026 12.629 12.4992 12.6237 12.5683C12.6335 12.795 12.4794 13.0165 12.5007 13.2522C12.4767 13.3018 12.4784 13.3504 12.4714 13.3992C12.4316 13.447 12.3474 13.4958 12.3872 13.5525C12.2668 16.4491 11.8634 19.476 12.4023 22.3218C12.4448 22.3555 12.4341 22.3899 12.4359 22.4237C12.4244 22.4758 12.505 22.5176 12.5111 22.568C12.5484 22.86 12.6071 23.179 12.6935 23.4397C12.8663 23.5186 12.7946 23.6416 12.9274 23.7045C12.9797 23.7213 12.9938 23.7408 12.9948 23.7638C13.0204 23.817 13.1285 23.8277 13.1453 23.872C13.6784 23.7451 14.0181 23.3325 14.2703 22.8627ZM65.7063 37.8858C65.8373 40.7141 64.1013 39.9683 62.1232 40.1109C60.4439 40.1269 58.3914 40.1552 56.7156 40.1144C55.1495 40.0523 53.5711 40.071 52.005 39.9869C51.2034 39.8664 49.8525 40.1898 49.5735 39.1861C49.4277 37.6163 49.7037 35.809 50.6037 34.5029C51.0821 35.6003 51.0821 36.8112 51.1964 38.0053C55.1532 37.5171 59.3677 37.8219 63.3663 37.6872C63.8424 33.3182 62.3645 28.3066 57.1159 28.475C54.5938 28.5693 52.112 30.3645 51.3639 32.7763C51.0317 33.2821 51.208 34.004 50.82 34.5027C50.7429 34.377 50.7669 34.2246 50.7359 34.0829C50.6853 34.2344 50.658 34.0952 50.5764 34.0563C50.516 34.0952 50.5383 34.1875 50.4949 34.2406C49.8732 31.5141 51.6332 28.421 54.2082 27.3058C51.5444 25.2211 52.5455 19.8376 56.2402 19.8226C56.9213 19.8589 57.0922 19.9528 57.4767 20.4843C57.4263 20.5206 57.3748 20.5392 57.3456 20.619C57.3023 20.6659 57.234 20.6261 57.2013 20.7138C57.066 20.8488 56.8842 20.8792 56.77 21.0672C56.2877 21.2198 55.8079 21.5949 55.5919 22.0371C54.2434 24.0195 55.782 26.9309 58.2839 26.0082C60.594 25.3882 60.3916 22.196 58.513 21.2045C58.4237 21.1611 58.2722 21.2195 58.2404 21.1035C58.044 20.8867 57.6282 21.0326 57.4768 20.6987C57.5309 20.6234 57.6036 20.6403 57.677 20.6048C57.6053 20.5632 57.6823 20.5038 57.6948 20.4437C57.3333 20.1 59.0191 20.1451 59.2325 20.2248C62.2495 20.8139 62.7597 25.2322 60.6242 27.1011C65.113 28.9253 65.9728 33.5467 65.7063 37.8858ZM67.872 20.4082C67.7383 18.3806 67.6205 16.3698 67.4565 14.352C67.6132 13.9405 66.8832 11.8147 66.4485 11.9728C66.3944 11.9683 66.3263 11.9232 66.2864 11.9666C66.2474 11.9187 66.2581 11.8798 66.181 11.8488C65.7887 12.0091 66.0605 12.1952 65.8852 12.3706C65.7789 12.4024 65.8816 12.499 65.8754 12.5682C65.8852 12.7949 65.7311 13.0163 65.7524 13.252C65.7284 13.3016 65.7301 13.3502 65.7231 13.399C65.6832 13.4469 65.5999 13.4957 65.6389 13.5523C65.5191 16.449 65.1151 19.476 65.654 22.3216C65.6965 22.3554 65.6868 22.3898 65.6877 22.4235C65.6762 22.4757 65.7568 22.5174 65.7631 22.5678C65.8004 22.8598 65.8591 23.1787 65.9455 23.4395C66.1183 23.5184 66.0466 23.6414 66.1794 23.7043C66.2316 23.7211 66.2458 23.7406 66.2476 23.7637C66.2724 23.8168 66.3813 23.8275 66.3972 23.8718C67.7404 23.5886 67.8642 21.6158 67.872 20.4082ZM59.7368 13.9765C59.8328 13.4968 59.9703 13.0021 59.9981 12.5176C59.9575 12.4893 60.0504 12.4786 60.0823 12.4573C60.1117 12.4198 60.1226 12.2653 60.2338 12.18C60.2943 12.1336 60.1196 12.0661 60.2453 12.0533C60.3037 12.0462 60.3029 12.0232 60.3152 11.9877C60.2228 11.9181 60.5504 11.7912 60.6456 11.8955C61.1234 11.8427 61.8096 12.3064 61.8175 12.8211C61.978 14.2688 63.0538 16.4266 60.7564 16.569C60.7015 16.545 60.5269 16.5141 60.4648 16.475C60.4648 16.4219 60.2194 16.4227 60.2557 16.3147C60.2717 16.2616 60.1397 16.2128 60.1538 16.1624C60.1656 16.0562 60.0423 16.0139 60.0476 16.0013C60.0528 15.9827 60.0396 15.9702 60.0077 15.9562C59.6311 15.4893 59.8757 14.5856 59.7368 13.9765ZM48.9028 13.2227C48.9989 12.7422 49.1367 12.2501 49.1658 11.7638C49.125 11.7355 49.2164 11.725 49.249 11.7037C49.2812 11.6656 49.2796 11.5262 49.4013 11.4274C49.4592 11.3803 49.2871 11.3117 49.4111 11.2998C49.4704 11.2928 49.4687 11.2688 49.481 11.2342C49.3898 11.1635 49.7184 11.0395 49.8132 11.1421C50.29 11.0901 50.9772 11.5536 50.9832 12.0677C51.1325 12.4507 51.0743 12.9496 51.2092 13.3334C51.2597 13.8499 51.5271 14.4098 51.3066 14.9198C51.2866 15.5989 50.1693 15.9432 49.6306 15.7224C49.6324 15.6675 49.3861 15.6693 49.4234 15.5613C49.4376 15.5099 49.3064 15.4594 49.3197 15.409C49.3336 15.301 49.2088 15.2614 49.2143 15.2477C49.2186 15.2309 49.2063 15.2166 49.1752 15.2026C48.7984 14.7461 49.0415 13.8282 48.9028 13.2227ZM28.597 13.2227C28.6959 12.7422 28.8316 12.2501 28.861 11.7638C28.8202 11.7355 28.9116 11.725 28.9434 11.7037C28.9741 11.6682 28.9796 11.5194 29.0957 11.4274C29.156 11.3795 28.9812 11.3117 29.1063 11.2998C29.1666 11.2928 29.1647 11.2706 29.1762 11.2342C29.0863 11.1622 29.4149 11.0398 29.5084 11.1421C29.9861 11.0899 30.6724 11.5536 30.6784 12.0677C30.8252 12.4498 30.7692 12.9499 30.9044 13.3334C30.9557 13.8499 31.2215 14.4098 31.0018 14.9198C30.984 15.5987 29.8639 15.9434 29.326 15.7224C29.3277 15.6675 29.0823 15.6693 29.1188 15.5613C29.1328 15.5099 29.001 15.4594 29.0151 15.409C29.0298 15.3024 28.9037 15.2619 28.9096 15.2477C28.9141 15.2309 28.9016 15.2166 28.8708 15.2026C28.4893 14.7352 28.7397 13.8336 28.597 13.2227ZM32.0197 24.5758C32.1269 23.1296 32.2376 21.5506 33.1234 20.3666C33.6016 21.4622 33.6016 22.6731 33.7168 23.8672C37.6728 23.3792 41.8874 23.6848 45.884 23.5501C46.3634 19.1776 44.8826 14.1709 39.6336 14.3371C37.1124 14.4317 34.6303 16.227 33.8834 18.6402C33.5512 19.1443 33.7276 19.8678 33.3396 20.3666C33.2624 20.239 33.2864 20.0866 33.2554 19.9458C33.2048 20.0963 33.1775 19.9573 33.0959 19.9182C33.0357 19.9573 33.0578 20.0494 33.0144 20.1024C32.3927 17.376 34.1527 14.2827 36.7268 13.1675C34.0645 11.0826 35.0642 5.70001 38.7597 5.68433C39.4408 5.72065 39.6117 5.81633 39.9962 6.34609C39.9439 6.38241 39.8952 6.40193 39.8652 6.48081C39.8218 6.52769 39.7535 6.48881 39.7208 6.57745C39.5842 6.71025 39.4037 6.74209 39.2895 6.92913C38.8072 7.08337 38.3284 7.45729 38.1114 7.90001C36.7631 9.88321 38.2999 12.7944 40.8034 11.8701C43.1136 11.2499 42.9112 8.06081 41.0325 7.06641C40.9432 7.02481 40.7917 7.08145 40.7599 6.96545C40.5629 6.74929 40.1488 6.89553 39.9964 6.56241C40.0504 6.48529 40.1231 6.50225 40.1965 6.46673C40.1229 6.42513 40.2018 6.36577 40.2143 6.30561C39.8528 5.96193 41.5386 6.00705 41.752 6.08865C44.769 6.67681 45.2792 11.0942 43.1436 12.9632C47.6317 14.7917 48.4936 19.4069 48.2258 23.7496C48.2802 24.7326 48.0172 26.0632 46.7655 25.9312C43.2148 26.0326 39.5284 25.9904 35.9933 25.909C34.7567 25.655 32.0279 26.4432 32.0197 24.5758ZM38.0112 41.6229L38.1575 40.8256C36.9351 40.799 35.6508 40.799 34.4301 40.7822C33.6188 40.8061 33.0935 39.8326 33.5426 39.1666C36.0925 35.0971 39.1756 31.3603 42.0684 27.5565C41.9479 27.7682 41.846 27.9144 41.7264 28.1101C41.8231 27.9923 41.6821 28.2253 41.6618 28.2811C41.6733 28.2909 41.745 28.1694 41.769 28.1491C39.6794 31.609 38.1576 35.3843 36.0274 38.8069C41.2189 38.7467 40.754 38.1408 39.9125 43.2642C40.8932 41.6387 42.321 39.3712 43.321 37.7616C41.3093 37.5605 38.4802 38.5278 39.5839 35.3186C40.2447 32.7861 41.4856 30.3555 41.9914 27.7584C41.9719 30.3219 41.8807 32.8792 41.6495 35.4408C42.9728 35.3842 44.2972 35.393 45.6196 35.415C46.8996 35.4886 46.9421 36.9466 46.2112 37.7191C45.1962 39.3302 43.576 41.8469 42.6079 43.4563C41.9197 44.5307 40.9586 46.0907 40.258 47.1474C39.521 48.0534 38.9834 50.1979 37.4482 49.3866C36.5572 48.8578 36.961 47.8117 37.0452 46.9931C37.2972 45.352 37.6879 43.2544 38.0112 41.6229ZM57.1903 55.2144C57.3063 53.1186 56.8511 51.0442 56.5986 48.9819C55.9088 49.5202 54.9317 49.3202 54.114 49.4638C53.2034 49.6152 52.2325 49.7915 51.3032 49.6117C57.9092 73.8554 21.8554 73.2875 28.3818 49.2883C26.8858 49.4206 25.3431 49.8578 23.8359 49.5851C17.5687 75.3739 55.3552 81.4339 57.1903 55.2144ZM25.06 44.9127C25.1477 44.6699 25.2346 44.4272 25.3213 44.1854C26.8962 44.1774 28.4756 44.22 30.0594 44.2005C29.5988 45.2653 29.2029 46.3565 28.868 47.4699C27.3618 47.296 25.8671 47.1763 24.3399 47.2963C24.5498 46.4947 24.7828 45.6939 25.06 44.9127ZM58.449 54.6741C58.1434 51.0104 57.3213 47.1573 55.7464 43.8976C55.773 44.0952 55.9076 44.3883 55.904 44.5539C55.726 44.3891 55.6064 44.0374 55.7314 44.5477C55.5746 44.165 55.378 43.7328 55.2645 43.3563C55.3176 44.7859 55.9626 46.1589 56.2903 47.5594C56.2487 47.5336 56.2397 47.4301 56.1946 47.4734C55.0213 47.4022 53.8717 47.1082 52.6904 47.2786C52.094 47.3198 51.393 47.1707 50.948 47.5699C50.9037 47.624 50.824 47.6168 50.7594 47.6293C50.3306 46.2839 49.7496 45.0021 49.1898 43.7061C51.2413 43.5262 53.3044 43.4067 55.3868 43.179C53.0309 42.697 50.7856 42.4941 48.3837 42.3925C46.8575 42.7707 48.397 45.18 48.5954 46.1367C49.8639 50.523 51.1324 56.1213 48.7274 60.2862C44.4898 67.9571 32.7487 66.4867 30.4288 58.0718C29.4872 54.2195 30.4784 50.151 31.7124 46.4494C32.7354 43.8346 34.1023 41.4075 29.8868 41.8779C28.2756 41.8886 26.6624 41.8894 25.0495 41.8894C24.4525 41.8654 23.6773 41.8842 23.4568 42.5901C9.009 74.2104 56.0736 88.904 58.449 54.6741Z" fill="white" />
    </svg>
  ),
  Generate: () => (
    <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 80 80" fill="none">
      <path d="M69.4096 7.77997C68.7127 10.7484 67.5765 15.6408 66.8565 18.6308C65.7939 25.0923 63.5867 18.7596 62.2597 16.6545C57.2738 21.3148 52.18 26.0489 47.1774 30.7027C46.6533 31.2177 45.8138 32.1142 45.0506 31.4664C43.2134 30.0782 41.3774 28.6904 39.5298 27.3177C30.5525 33.6502 21.4566 40.022 12.3843 46.2171C11.2632 47.0272 9.90144 45.3624 10.9226 44.4284C19.9739 35.9057 28.7405 26.9716 38.6286 19.443C33.2544 25.5505 27.2838 31.0656 21.6936 36.9654C27.2886 33.0913 33.2816 28.8742 38.879 24.988C39.3054 24.6915 39.8614 24.7195 40.2539 25.0172C41.7162 26.159 44.204 27.9788 45.6267 29.1104C50.2158 24.8412 55.063 20.3193 59.7315 16.1027C63.2896 12.6003 62.9694 13.7372 65.0562 17.4432C65.772 14.5793 66.4741 11.719 67.1704 8.85149C63.8478 9.38701 60.5246 9.92557 57.2005 10.4532L60.293 12.0724C60.9021 12.3726 60.9866 13.2593 60.4522 13.6721C55.8451 17.3689 51.1107 20.8636 46.5547 24.6172C45.6371 25.1734 44.768 23.923 44.0339 23.5046C42.2286 22.2676 40.3094 21.0843 38.6493 19.6507C39.0755 19.8585 39.5608 20.196 39.9949 20.4483C39.6485 20.168 39.7181 20.251 40.0534 20.3281C37.6328 18.5779 45.4909 23.4241 46.053 23.6758C50.1445 20.0966 54.2258 16.4929 58.4587 13.0728C57.4819 12.5784 55.3707 11.4811 54.383 10.9732C53.8125 10.7347 53.06 10.3086 53.4298 9.58333C53.7898 8.81853 57.9744 8.63181 59.0659 8.29565C62.081 7.77357 65.104 7.27869 68.1174 6.74557C68.7962 6.49645 69.5915 7.02493 69.4096 7.77997ZM65.8307 43.1899C65.8643 47.7622 64.2651 52.4248 63.6922 57.0011C63.3182 59.28 62.9312 61.1544 60.957 62.6236C63.6549 64.4054 62.8344 69.7188 59.4034 69.5133C59.444 69.4219 59.5182 69.4136 59.5827 69.3556C59.4995 69.3425 59.5541 69.2641 59.5451 69.2038C59.339 69.1392 59.4864 69.0732 59.5773 68.9796C62.3794 66.5712 59.7203 62.0884 57.1122 64.7315C55.7304 66.8196 57.9768 68.1613 59.3555 69.3104C58.8061 70.0558 57.6878 69.9396 56.8862 69.5969C54.8245 69.1174 53.9381 66.572 54.5851 64.676C52.2501 65.2265 48.7101 66.1073 46.3741 66.6325C48.4354 68.6475 47.2734 73.2017 44.232 72.9579C44.2726 72.8665 44.3469 72.8582 44.4114 72.8003C44.3282 72.7873 44.3827 72.7088 44.3736 72.6485C44.1675 72.5838 44.3149 72.5179 44.4058 72.4243C47.2078 70.0158 44.5488 65.5329 41.9406 68.1761C40.5589 70.2643 42.8053 71.6059 44.184 72.755C43.6344 73.5003 42.5163 73.3843 41.7147 73.0416C39.4211 72.4969 38.6296 69.5065 39.6451 67.5398C36.1963 66.5993 32.9002 58.5868 30.8982 55.4742C28.3747 53.2433 26.7579 50.056 24.7525 47.3316C23.6 45.0764 22.4661 45.7939 20.4853 46.0268C19.9674 46.1609 19.4002 46.0745 18.9101 46.3049C18.603 46.1668 18.2202 46.5008 17.9235 46.2086C17.9571 46.1212 18.0267 46.1166 18.0859 46.0633C18.0086 46.0446 18.0622 45.9688 18.0555 45.9097C18.0032 45.8592 17.9133 45.8857 17.9685 45.806C19.0304 44.9665 20.2616 44.2966 21.588 44.0233C25.6886 42.7448 27.4075 47.6838 29.5382 50.196C30.8667 49.8153 32.2098 49.4355 33.5286 49.0358C32.7222 47.1744 32.7688 44.8892 32.7506 42.8041C32.7381 41.8211 32.4555 40.2273 33.8861 40.2137C41.7962 40.2323 40.6245 39.2976 39.9694 47.148C40.9776 46.8707 43.1294 46.3273 44.1678 46.0544C43.5717 43.3404 43.5189 40.4552 43.5373 37.6508C43.6971 36.1345 42.7021 33.3204 45.2043 33.6334C46.8587 33.6467 48.5166 33.539 50.1742 33.6737C51.092 33.7014 51.328 34.6483 51.2038 35.406C51.0654 38.3963 51.1243 41.475 50.748 44.375C51.9066 44.0897 53.804 43.6019 54.9584 43.3091C54.1218 37.8675 54.3659 32.1908 54.2915 26.6712C54.2797 24.8451 56.5326 25.5468 57.7021 25.3979C58.6914 25.3473 59.9536 25.3673 60.9464 25.3974C62.6389 25.548 61.8845 27.6684 61.9906 28.7948C61.8661 33.1 61.8818 37.4683 61.5275 41.7067C63.2299 41.1009 65.1581 41.2446 65.8307 43.1899ZM56.5698 27.6382C56.5934 32.7611 57.0686 38.0768 55.8448 43.0915C57.0638 42.7793 59.5533 42.1732 60.784 41.8843C59.791 37.183 60.0493 32.3305 59.9405 27.5505C58.8402 27.6265 57.6742 27.588 56.5698 27.6382ZM45.8251 35.8683C45.8096 39.1664 46.1936 42.6499 45.1018 45.8155C46.7149 45.4012 48.3493 44.9825 49.9685 44.5721C49.0885 41.7083 49.2723 38.7011 49.1634 35.743C48.0605 35.8248 46.932 35.8321 45.8251 35.8683ZM34.1445 48.8529C35.8253 48.3532 37.5014 47.8476 39.188 47.3648C38.452 45.7646 38.5013 44.0299 38.4101 42.3174C37.2955 42.3254 36.185 42.4454 35.0707 42.4524C35.0146 44.5851 35.3496 46.9814 34.1445 48.8529ZM63.7403 43.6256C52.5918 45.1932 41.0646 48.596 29.7467 50.5161C30.4878 51.8089 31.4731 53.0326 31.6878 54.5429C33.509 57.4244 35.7976 60.1092 37.7483 62.9184C38.5851 64.2816 39.7917 65.8518 41.5819 65.3744C46.865 64.1185 53.1192 62.6657 58.3819 61.3585C62.1238 60.2787 61.4218 55.1283 62.3154 52.0776C62.6394 50.3121 63.1939 47.4096 63.557 45.6475C63.5301 45.346 64.1102 43.8966 63.7403 43.6256ZM30.6694 65.7923C29.2437 63.7436 23.437 64.8004 21.0934 64.7288C19.017 65.0182 14.5739 64.4694 13.2262 65.9097C13.2198 65.967 13.1552 66.0286 13.2192 66.066C13.1549 66.1033 13.0928 66.092 13.045 66.1678C18.3725 67.2689 24.6318 67.1788 30.1413 66.3955C30.2566 66.2315 30.427 66.3014 30.5306 66.1693C30.561 66.0856 30.625 66.127 30.6638 66.0835C30.6915 66.008 30.7344 65.9923 30.7779 65.9595C30.7202 65.9057 30.7203 65.9057 30.6694 65.7923ZM20.1749 60.6833C20.8504 61.5648 25.8467 61.5113 27.1902 61.2854C27.4296 61.0566 27.8522 61.0459 28.1062 60.9108C28.1603 60.744 28.2437 60.8124 28.2869 60.6846C28.299 60.635 28.3123 60.6217 28.3277 60.6196C28.3618 60.5892 28.3746 60.4905 28.4016 60.4748C28.0072 58.4908 25.5336 59.1376 24.0763 59.2321C22.7802 59.4817 21.0674 59.0787 20.2238 60.356C20.293 60.4112 20.2184 60.5176 20.256 60.5816C20.2205 60.6222 20.1954 60.6115 20.1749 60.6833Z" fill="white" />
    </svg>
  ),
  VerticalConnector: () => (
    <svg width="1" height="24" viewBox="0 0 1 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect width="1" height="24" fill="#85C3DE" />
    </svg>

  ),

  Infinity: () => (
    < svg xmlns="http://www.w3.org/2000/svg" width="154" height="62" viewBox="0 0 154 62" fill="none" >
      <path d="M1 33.9597C1 46.6346 14.4971 54.7471 25.69 48.7997L109.064 4.49877C128.755 -5.96422 152.5 8.3077 152.5 30.6061C152.5 52.0822 130.325 66.3924 110.756 57.5445L24.7282 18.6474C13.6049 13.6181 1 21.7523 1 33.9597Z" stroke="url(#paint0_linear_2576_2451)" strokeWidth="2" />
      <defs>
        <linearGradient id="paint0_linear_2576_2451" x1="152.5" y1="28.9188" x2="1" y2="28.9188" gradientUnits="userSpaceOnUse">
          <stop offset="0.235577" stopColor="#344A90" />
          <stop offset="0.5" stopColor="#3366FB" />
          <stop offset="0.774038" stopColor="#344A90" />
        </linearGradient>
      </defs>
    </svg >
  ),
};

const BusinessWebsite = () => {


  const items = [
    "Clear business positioning",
    "Built-in credibility and proof",
    "Conversion-focused structure",
    "Self-explanatory pages",
    "Website designed as a business tool",
  ];

  // const actions = [
  //   { id: 1, icon: ChatBubbleLeftRightIcon },
  //   { id: 2, icon: ShoppingBagIcon },
  //   { id: 3, icon: TruckIcon },
  //   { id: 4, icon: CreditCardIcon },
  // ]

  const [activeContent, setActiveContent] = useState("new_content1");
  const contentRefs = useRef({});


  const [isMobile, setIsMobile] = useState<boolean | null>(null);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth < 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const faqs = [
    {
      question: "Why does my business really need a professional website?",
      answer: `
      Because today, your website is your 24×7 digital salesperson. A professional business website builds trust, attracts the right customers, and converts visitors into real leads and sales — even when you’re offline.
    `
    },
    {
      question: "What makes Vilva Business websites different?",
      answer: `
      We don’t build “just websites.”
      <br/><br/>
      We create AI-powered, conversion-focused business websites designed to:
      <ul>
        <li>Generate more enquiries</li>
        <li>Capture leads automatically</li>
        <li>Build instant credibility</li>
        <li>Support business growth from day one</li>
      </ul>
      Every website is built with strategy, speed, and scalability in mind.
    `
    },
    {
      question: "Will my website help me get more leads and enquiries?",
      answer: `
      Absolutely. Our business websites are designed with:
      <ul>
        <li>Strong call-to-actions</li>
        <li>Lead capture forms</li>
        <li>WhatsApp & chat integration</li>
        <li>SEO-ready structure</li>
      </ul>
      The goal is simple: turn visitors into customers.
    `
    },
    {
      question: "Is the website mobile-friendly and fast?",
      answer: `
      Yes — 100%. Your website will look and perform beautifully on mobile, tablet, and desktop, with fast loading speeds that keep visitors engaged and improve search rankings.
    `
    },
    {
      question: "Will my business website be SEO-friendly?",
      answer: `
      Yes. Every Vilva Business website is built with SEO best practices so search engines and AI systems can easily understand, rank, and recommend your site.
      <br/><br/>
      This helps your business appear in:
      <ul>
        <li>Google search results</li>
        <li>AI-generated answers (ChatGPT, Gemini, etc.)</li>
      </ul>
    `
    },
    {
      question: "Can I update the website content myself?",
      answer: `
      Yes! If your website is built as a dynamic website, you can easily update content anytime. We use an easy-to-manage CMS that lets you:
      <ul>
        <li>Update text and images</li>
        <li>Add or modify services and pages</li>
        <li>Manage content without technical knowledge</li>
      </ul>
      You get full control over your website — simple, flexible, and stress-free.
    `
    },
    {
      question: "Can you integrate WhatsApp, chatbots, or AI support?",
      answer: `
      Definitely. We can integrate:
      <ul>
        <li>WhatsApp enquiry buttons</li>
        <li>Live chat</li>
        <li>AI chatbots for instant responses</li>
      </ul>
      So your customers can reach you instantly, anytime.
    `
    },
    {
      question: "How long does it take to build a business website?",
      answer: `
      A standard business website can be launched in 7–14 days. More advanced or custom websites may take a bit longer — but we always move fast without compromising quality.
    `
    },
    {
      question: "Is the website secure and reliable?",
      answer: `
      Yes. We follow modern security standards, SSL protection, and best hosting practices to keep your website safe, stable, and trustworthy.
    `
    },
    {
      question: "Why should I choose Vilva Business for my website?",
      answer: `
      Because we combine:
      <ul>
        <li>Smart design</li>
        <li>Business strategy</li>
        <li>SEO & AI readiness</li>
        <li>Automation & growth tools</li>
      </ul>
      We build websites that don’t just look good — they work for your business.
    `
    }
  ];


  useEffect(() => {
    const headings = document.querySelectorAll(".new_heading");
    headings.forEach((heading) => {
      heading.addEventListener("click", () => {
        const contentId = heading.getAttribute("data-content");
        if (contentId) { // Type guard to ensure contentId is not null
          setActiveContent(contentId);
          const targetElement = contentRefs.current[contentId];
          if (targetElement) {
            targetElement.scrollIntoView({ behavior: "smooth", block: "start" });
          }
        }
      });
    });

    return () => {
      headings.forEach((heading) => {
        heading.removeEventListener("click", () => { });
      });
    };
  }, []);


  // Animation variants for fade-in effect
  const fadeIn: Variants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } }
  };

  // Hook for in-view detection
  const [heroRef, heroInView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [statsRef, statsInView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [allInOneRef, allInOneInView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [storeRef, storeInView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [clientsRef, clientsInView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [dashboardRef, dashboardInView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [pricingRef, pricingInView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [testimonialsRef, testimonialsInView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [statsSectionRef, statsSectionInView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [faqRef, faqInView] = useInView({ triggerOnce: true, threshold: 0.2 });
  const [freedomRef, freedomInView] = useInView({ triggerOnce: true, threshold: 0.2 });


  const fadeInUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: [0.16, 1, 0.3, 1] as const, },
    },
  };

  const [activeIndex, setActiveIndex] = useState(null);

  const toggleAnswer = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const staggerChildren = {
    hidden: { opacity: 1 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.18,
      },
    },
  };

  const scaleIn = {
    hidden: { opacity: 0, scale: 0.92 },
    visible: {
      opacity: 1,
      scale: 1,
      transition: { duration: 1.1, ease: 'easeOut' },
    },
  };


  function ComparisonRow({
    problem,
    solution,
    showConnector = true,
  }: {
    problem: string;
    solution: string;
    showConnector?: boolean;
  }) {
    return (
      <div className="flex flex-col sm:flex-row items-center justify-center relative">

        {/* Problem Box */}
        <div className="relative w-full px-[24px] py-[16px] rounded-xl border border-[#85C3DE] bg-[#F0F3F4] text-center">
          <p className="font-semibold text-lg sm:text-[18px] md:text-[20px] leading-[120%] text-[#090D28] font-Schibsted_Grotesk text-center">
            {problem}
          </p>
        </div>

        {/* Horizontal Arrow (desktop) */}
        <div className="md:block hidden">
          <svg xmlns="http://www.w3.org/2000/svg" width="66" height="7" viewBox="0 0 66 7" fill="none">
            <rect y="3" width="66" height="1" fill="url(#paint0_linear_2576_2391)" />
            <path d="M66 7V0C65 2.1 63 3.5 63 3.5C63 3.5 65 4.9 66 7Z" fill="#85C3DE" />
            <path d="M2.38419e-07 7V0C1 2.1 3 3.5 3 3.5C3 3.5 1 4.9 2.38419e-07 7Z" fill="#D4E1E7" />
            <defs>
              <linearGradient id="paint0_linear_2576_2391" x1="0" y1="3.5" x2="66" y2="3.5" gradientUnits="userSpaceOnUse">
                <stop stopColor="#D4E1E7" />
                <stop offset="1" stopColor="#85C3DE" />
              </linearGradient>
            </defs>
          </svg>
        </div>

        {/* Vertical Arrow (mobile) */}
        <div className="md:hidden">
          <svg width="1" height="8" viewBox="0 0 1 8" fill="none">
            <rect width="1" height="8" fill="#85C3DE" />
          </svg>
        </div>

        {/* Solution Box */}
        <div className="relative w-full px-[24px] py-[16px] rounded-xl border border-[#407A93] bg-[#F3FBFF] text-center">
          <p className="font-semibold text-[18px] md:text-[20px] text-[#25586E] font-Schibsted_Grotesk">
            {solution}
          </p>

          {/* Bottom vertical connector */}
          {showConnector && (
            <svg
              width="1"
              height="24"
              viewBox="0 0 1 24"
              fill="none"
              className="
              absolute
              left-1/2
              -bottom-[24px]
              -translate-x-1/2
              hidden sm:block
            "
            >
              <rect width="1" height="24" fill="#85C3DE" />
            </svg>
          )}
        </div>
      </div>
    );
  }


  return (
    <>
      <div className="relative min-h-[90vh] md:min-h-screen bg-cover bg-center text-white overflow-hidden pb-[200px] md:pb-0">
        {/* <Image
          src={bgimg}
          alt="Hero background"
          fill
          priority                          // ✅ removes lazy loading, adds preload
          className="object-cover z-0"

          quality={75}
        /> */}
        <Image
          src={getImageUrl("/vilvabusiness/website/products/business-website/BgImg.webp")}
          alt=""
          fill
          priority
          sizes="100vw"
          className="absolute inset-0 object-cover -z-10"
        />
        <div className="absolute z-50 mt-10 w-full flex flex-col items-center text-center md:gap-[16px] gap-[8px] px-4">
          <h1 className="font-NeueMontreal font-bold text-[36px] sm:text-[44px] md:text-[56px] lg:text-[64px] leading-[1.15] max-w-5xl">
            Business websites built to <br />
            generate leads, trust, and revenue
          </h1>

          <p className="font-Schibsted_Grotesk text-white/90
      text-[16px] sm:text-[18px] md:text-[20px]
      max-w-4xl leading-relaxed">
            We build high-performance business websites that generate leads,
            automate follow-ups, and increase sales — powered by SEO,
            marketing, and WhatsApp integration.
          </p>

          {/* Two paths, not one. Booking a demo is a high-commitment ask; a visitor who is still
              deciding previously had nowhere to go from here — this was the only link on the whole
              page. The secondary CTA points at /choosetheme ("Pick a professional, mobile-friendly
              website theme"), which is the natural low-commitment next step for this page.
              The row was flex-col, which would have stacked the two buttons vertically. */}
          <div className="flex flex-col items-center md:gap-[20px] !gap-[10px]">
            <div className="flex flex-col sm:flex-row items-center gap-[12px]">
              <Link
                href="/book-demo"
                className="inline-flex items-center justify-center font-Schibsted_Grotesk min-h-[44px] min-w-[44px] px-8 py-3 rounded-[8px] bg-blue-600 text-white font-medium hover:bg-blue-700 transition-colors"
              >
                Book a Free Demo
              </Link>

              <Link
                href="/choosetheme"
                className="inline-flex items-center justify-center font-Schibsted_Grotesk min-h-[44px] min-w-[44px] px-8 py-3 rounded-[8px] border border-white/40 text-white font-medium hover:bg-white/10 transition-colors"
              >
                Browse Website Themes
              </Link>
            </div>

            <p className="text-white/80 text-sm font-Schibsted_Grotesk ">
              ⚡ Get a response within 24 hours
            </p>
          </div>
        </div>


        <div className="absolute bottom-[-40px] md:bottom-[-80px] lg:bottom-[-120px] left-0 right-0 flex justify-center px-4">
          {/* <Image
            src={hero}
            alt="Hero Card"
            className="w-full max-w-5xl h-auto "
            priority
          /> */}
          <Image
            src={
              isMobile
                ? getImageUrl("/vilvabusiness/website/products/business-website/hero_2_bs_4-desktop.svg")
                : getImageUrl("/vilvabusiness/website/products/business-website/hero_2_bs_4-desktop.svg")
            }
            alt="Example of a high-performance business website by Vilva Business"
            width={800}
            height={500}
            quality={75}
            priority
            sizes="(max-width: 768px) 100vw, 665px"
            className="w-full max-w-5xl h-auto"
          />
        </div>
      </div>

      <TrustedPartners className="relative md:mt-[40px] mt-[20px]" />

      <section className="bg-gradient-to-b from-white via-white to-[#E7F7FE] py-12 md:py-20">
        <div className="container mx-auto px-4 max-w-[1340px]">
          <div className="mb-8 md:mb-12">
            <h2 className="text-[36px] lg:text-[48px] font-[700] font-NeueMontreal text-[#090D28] leading-[120%] mb-4 lg:max-w-7xl mx-auto text-start">
              We design websites as business
              <br className="space-y-6" />
              tools, not visual showcases.
            </h2>
            <br className="mt-[6px]" />
            <p className="font-body text-base md:text-lg leading-[120%] text-[#090D28] opacity-80 max-w-4xl font-Schibsted_Grotesk md:ml-3">
              Your website may look modern and well-designed, but it still struggles to support your business goals.
            </p>
          </div>

          {/* Divider */}
          <div className="h-px bg-black opacity-10 mb-8 md:mb-12"></div>

          {/* Comparison Grid */}
          <div className="grid grid-cols-1 lg:grid-cols-[370px_1fr] gap-8 lg:gap-16 items-start mb-8 md:mb-12">
            {/* Geometric Visual */}
            <div className="flex justify-center lg:justify-start">
              <Image
                src={getImageUrl("/vilvabusiness/website/mobile-img/cube.webp")}
                width={800}
                height={500}
                quality={75}
                alt="Business tools visualization"
                className="w-full max-w-[370px] h-auto"
              />
            </div>

            <div className="space-y-3">
              <ComparisonRow
                problem="Unclear business messaging"
                solution="Clear business positioning"
              />
              <ComparisonRow
                problem="Low trust from decision-makers"
                solution="Built-in credibility and proof"
              />
              <ComparisonRow
                problem="Traffic without conversions"
                solution="Conversion-focused structure"
              />
              <ComparisonRow
                problem="Heavy dependency on sales teams"
                solution="Self-explanatory pages"
              />
              <ComparisonRow
                problem="No measurable business impact"
                solution="Website designed as a business tool"
                showConnector={false}
              />
            </div>
          </div>

          {/* Bottom Description */}
          <div className="text-center max-w-7xl mx-auto">
            <p className="font-body text-base leading-[150%] text-[#090D28] opacity-80 font-Schibsted_Grotesk">
              Business websites often fail at the fundamentals — clarity, trust, and conversion. This leads to low enquiries, heavy sales dependency, and no measurable growth impact. We solve this by designing websites with clear positioning, built-in credibility, and conversion-focused structure, so the website works as a business tool, not just an online presence.
            </p>
          </div>
        </div>
      </section>

      {/* Three Pillars Section */}
      <section className="relative px-[17px] md:px-0 text-white overflow-hidden" style={{ background: "radial-gradient(84.3% 59.86% at 71.76% 50%, #2441A0 0%, #0D1B3A 100%)", }}>
        <div className="relative max-w-7xl mx-auto md:pb-0 pb-[40px]">
          {/* Heading */}
          <div className="text-center md:mt-[120px] mt-[60px]">
            <h2 className="text-[32px] md:text-[36px] lg:text-[48px] font-extrabold tracking-tight font-NeueMontreal max-w-xl mx-auto">
              <span className="text-[#1988FF] font-NeueMontreal">Three Pillars</span> That Turn a
              Website Into a Sales Engine
            </h2>
            <p className=" text-lg md:text-xl text-[#FFFFFF]/80 md:max-w-7xl max-w-[400px] mx-auto leading-relaxed font-Schibsted_Grotesk">
              A complete website ecosystem built for performance, scale, and growth — across your business
            </p>
          </div>

          {/* Desktop */}
          <div className="hidden md:flex relative flex flex-col items-center justify-center gap-12 md:gap-8 lg:gap-16 mt-8 md:mt-12">
            <div className="relative flex items-center justify-center gap-0">
              <div className="flex items-center justify-center">
                <div className="w-[160px] md:w-[180px] lg:w-[200px] flex flex-col items-center justify-center gap-[8px] p-[24px] bg-[radial-gradient(68.83%_68.83%_at_50%_31.17%,_#0C36AC_0%,_#0A1E57_100%)] rounded-[32px]">
                  <Icons.Org />
                  <p className="font-Schibsted_Grotesk">Organic Visibility</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-[80px] lg:w-[160px]"
                  height="10"
                  viewBox="0 0 156 10"
                  fill="none"
                >
                  <rect y="4" width="156" height="2" fill="url(#paint0_linear_2576_2474)" />
                  <path d="M156 10V0C154.667 3 152 5 152 5C152 5 154.667 7 156 10Z" fill="#344A90" />
                  <path d="M2.38419e-07 10V0C1.33333 3 4 5 4 5C4 5 1.33333 7 2.38419e-07 10Z" fill="#344A90" />
                  <defs>
                    <linearGradient id="paint0_linear_2576_2474" x1="0" y1="5" x2="156" y2="5" gradientUnits="userSpaceOnUse">
                      <stop offset="0.235577" stopColor="#344A90" />
                      <stop offset="0.5" stopColor="#3366FB" />
                      <stop offset="0.774038" stopColor="#344A90" />
                    </linearGradient>
                  </defs>
                </svg>
              </div>

              <div className="flex items-center justify-center">
                <div className="w-[160px] md:w-[180px] lg:w-[200px] flex flex-col items-center justify-center gap-[8px] p-[24px] bg-[radial-gradient(68.83%_68.83%_at_50%_31.17%,_#0C36AC_0%,_#0A1E57_100%)] rounded-[32px]">
                  <Icons.Lead />
                  <p className="font-Schibsted_Grotesk">Lead Generation</p>
                </div>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  className="w-[80px] lg:w-[160px]"
                  height="10"
                  viewBox="0 0 156 10"
                  fill="none"
                >
                  <rect y="4" width="156" height="2" fill="url(#paint0_linear_2576_2474)" />
                  <path d="M156 10V0C154.667 3 152 5 152 5C152 5 154.667 7 156 10Z" fill="#344A90" />
                  <path d="M2.38419e-07 10V0C1.33333 3 4 5 4 5C4 5 1.33333 7 2.38419e-07 10Z" fill="#344A90" />
                  <defs>
                    <linearGradient id="paint0_linear_2576_2474" x1="0" y1="5" x2="156" y2="5" gradientUnits="userSpaceOnUse">
                      <stop offset="0.235577" stopColor="#344A90" />
                      <stop offset="0.5" stopColor="#3366FB" />
                      <stop offset="0.774038" stopColor="#344A90" />
                    </linearGradient>
                  </defs>
                </svg>

              </div>

              <div className="w-[160px] md:w-[180px] lg:w-[200px] flex flex-col items-center justify-center gap-[8px] p-[24px] bg-[radial-gradient(68.83%_68.83%_at_50%_31.17%,_#0C36AC_0%,_#0A1E57_100%)] rounded-[32px]">
                <Icons.Generate />
                <p className="font-Schibsted_Grotesk whitespace-nowrap">Generate Sales</p>
              </div>
            </div>

            <div className="relative flex items-center justify-center gap-6 md:gap-8 lg:gap-[50px]">
              {/* The inline backgroundImage that used to be here pointed at /images/Pos/bg (3).png,
                  which 404s (the file lives in the repo's root images/, which Next does not serve).
                  Worse, being inline it overrode the gradient class below it — so this overlay
                  rendered nothing at all. Removing it restores the intended gradient. */}
              <div
                className="absolute bottom-0 left-0 w-full h-40 bg-[linear-gradient(180deg,rgba(13,26,58,0)_0%,#0D1A3A_100%)]"
              />

              {/* Pillar 1 */}
              <div className=" relative z-10 w-full max-w-[220px] md:max-w-[260px] lg:max-w-[320px]">
                {/* <Image src={pillar} alt="Organic Visibility Icon" /> */}

                <Image
                  src={getImageUrl("/vilvabusiness/website/mobile-img/pillar.webp")}
                  alt="Organic Visibility"
                  height={240}
                  width={300}
                  quality={75}
                  loading="lazy"
                  sizes="(max-width: 768px) 193px, (max-width: 1024px) 260px, 320px"  // ← fix
                  className="mx-auto" />
              </div>

              {/* Pillar 2 */}
              <div className=" relative z-10 w-full  max-w-[220px]  md:max-w-[260px]  lg:max-w-[320px]">
                {/* <Image src={pillar} alt="Lead Generation Icon" /> */}
                <Image
                  src={getImageUrl("/vilvabusiness/website/mobile-img/pillar.webp")}
                  alt="Lead Generation"
                  height={240}
                  width={300}
                  quality={75}
                  loading="lazy"
                  className="mx-auto" />
              </div>

              {/* Pillar 3 */}
              <div className=" relative z-10 w-full max-w-[220px] md:max-w-[260px] lg:max-w-[320px]">
                {/* <Image src={pillar} alt="Generate Sales Icon" /> */}
                <Image
                  src={getImageUrl("/vilvabusiness/website/mobile-img/pillar.webp")}
                  alt="Generate Sales"
                  height={240}
                  width={300}
                  quality={75}
                  loading="lazy"
                  className="mx-auto" />
              </div>
            </div>
          </div>


          {/* Mobile */}
          <div className="block md:hidden relative flex flex-col items-center justify-center gap-12 md:gap-8 lg:gap-16 mt-8 md:mt-12">
            <div className="relative flex flex-col gap-[24px] items-center justify-center">
              <div className="flex items-center justify-center border-1 border-[#FFF]/20 rounded-[32px]">
                <div className="w-[200px] flex flex-col md:flex-row items-center justify-center gap-[8px] p-[24px] bg-[radial-gradient(68.83%_68.83%_at_50%_31.17%,_#0C36AC_0%,_#0A1E57_100%)] rounded-[32px]">
                  <Icons.Org />
                  <p className="font-Schibsted_Grotesk">Organic Visibility</p>
                </div>
              </div>

              <div className="flex items-center justify-center border-1 border-[#FFF]/20 rounded-[32px]">
                <div className="w-[200px]  flex flex-col md:flex-row items-center justify-center gap-[8px] p-[24px] bg-[radial-gradient(68.83%_68.83%_at_50%_31.17%,_#0C36AC_0%,_#0A1E57_100%)] rounded-[32px]">
                  <Icons.Lead />
                  <p className="font-Schibsted_Grotesk">Lead Generation</p>
                </div>
              </div>

              <div className="w-[200px] flex flex-col md:flex-row items-center border-1 border-[#FFF]/20 rounded-[32px] justify-center gap-[8px] p-[24px] bg-[radial-gradient(68.83%_68.83%_at_50%_31.17%,_#0C36AC_0%,_#0A1E57_100%)]">
                <Icons.Generate />
                <p className="font-Schibsted_Grotesk">Generate Sales</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Everything your business website needs to perform, scale, and convert */}
      <div className="min-h-screen bg-white">
        <section className="container mx-auto px-4 py-12 md:py-20">
          <div className="max-w-4xl mx-auto text-center space-y-3">
            <h2 className="font-NeueMontreal font-bold text-3xl sm:text-4xl md:text-5xl lg:text-[48px] leading-[120%] text-[#090D28]">
              Everything your business website needs to perform, scale, and convert
            </h2>
            <p className="font-Schibsted_Grotesk text-base md:text-lg leading-[150%] text-[#090D28] opacity-80 md:max-w-7xl mx-auto">
              A complete website ecosystem built for performance, scale, and growth — across your business
            </p>
          </div>
        </section>

        {/* Features Grid */}
        <section className="container mx-auto px-4 pb-12 md:pb-20">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 max-w-7xl mx-auto">
            {/* Person Working Image Card */}
            <div className="rounded-2xl overflow-hidden bg-white ">
              {/* <Image
                src={personWorking}
                alt="Professional working on laptop"
                className="w-full h-full object-cover"
              /> */}
              {/* Desktop Image */}
              <Image
                src={getImageUrl("/vilvabusiness/website/products/business-website/person_working_bs_2-desktop.webp")}
                alt="Team building a high-performance business website"
                width={500}
                height={600}
                quality={75}
                loading="lazy"
                className="hidden md:block w-full h-full object-cover"
              />

              {/* Mobile Image */}
              <Image
                src={getImageUrl("/vilvabusiness/website/products/business-website/person_working_bs_1-mobile.webp")}
                alt="Team building a high-performance business website"
                width={390}
                height={400}
                quality={75}
                loading="lazy"
                className="block md:hidden w-full h-full object-cover"
              />
            </div>


            {/* Lead Generation Card */}
            <div className="rounded-2xl overflow-hidden bg-gradient-to-b from-[#E8F9FD] to-[#A9EFFF] p-6 md:p-8  flex flex-col">
              <div className="space-y-4 mb-8">
                <h2 className="font-NeueMontreal font-bold text-2xl leading-[120%] text-[#090D28]">
                  Lead Generation
                </h2>
                <p className="font-Schibsted_Grotesk text-base leading-[150%] text-[#090D28] opacity-80">
                  Capture high-intent leads through clear user journeys, focused CTAs, and smart forms designed to convert visitors into meaningful enquiries — not just collect data.
                </p>
              </div>
              <div className="flex-1 relative flex items-end justify-center">

    
                {/* Desktop Image */}
                <Image
                  src={getImageUrl("/vilvabusiness/website/products/business-website/business_website_img_1.svg")}
                  alt="Lead-generation forms and high-intent user journeys"
                  width={500}
                  height={600}
                  quality={75}
                  loading="lazy"
                  className=" w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Sales Enablement Card */}
            <div className="rounded-2xl overflow-hidden bg-gradient-to-b from-[#E8F9FD] to-[#A9EFFF] p-6 md:p-8  flex flex-col">
              <div className="space-y-4 mb-8">
                <h2 className="font-NeueMontreal font-bold text-2xl leading-[120%] text-[#090D28]">
                  Sales Enablement & Automation
                </h2>
                <p className="font-Schibsted_Grotesk text-base leading-[150%] text-[#090D28] opacity-80">
                  Automatically organize, route, and follow up on leads so your sales team responds faster, stays aligned, and focuses on closing instead of manual coordination.
                </p>
              </div>
              <div className="flex-1 relative flex items-end justify-center">
                <Image
                  src={getImageUrl("/vilvabusiness/website/products/business-website/business_website_img_2.svg")}
                  alt="Automated lead routing and sales follow-up"
                  width={500}
                  height={600}
                  quality={75}
                  loading="lazy"
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Marketing & Growth Integration Card */}
            <div className="rounded-2xl overflow-hidden bg-gradient-to-b from-[#E8F9FD] to-[#A9EFFF] p-6 md:p-8  flex flex-col">
              <div className="space-y-4 mb-8">
                <h2 className="font-NeueMontreal font-bold text-2xl leading-[120%] text-[#090D28]">
                  Marketing & Growth Integration
                </h2>
                <p className="font-Schibsted_Grotesk text-base leading-[150%] text-[#090D28] opacity-80">
                  Support ongoing growth with built-in integrations for email, WhatsApp, campaign tracking, and retargeting — so every marketing effort is measurable and optimizable.
                </p>
              </div>
              <div className="flex-4 relative flex items-end justify-center">
                <Image
                  src={getImageUrl("/vilvabusiness/website/products/business-website/container3.webp")}
                  alt="Marketing integrations: email, WhatsApp, and campaign tracking"
                  width={500}
                  height={600}
                  quality={75}
                  loading="lazy"
                  className="w-full h-full object-cover py-[150px]" />
              </div>
            </div>

            {/* Analytics & Business Insights Card */}
            <div className="rounded-2xl overflow-hidden bg-gradient-to-b from-[#E8F9FD] to-[#A9EFFF] p-6 md:p-8  flex flex-col">
              <div className="space-y-4 mb-8">
                <h2 className="font-NeueMontreal font-bold text-2xl leading-[120%] text-[#090D28]">
                  Analytics & Business Insights
                </h2>
                <p className="font-Schibsted_Grotesk text-base leading-[150%] text-[#090D28] opacity-80">
                  Gain complete visibility into how visitors become leads and leads become customers, with clear insights that help you improve performance and make informed decisions.
                </p>
              </div>
              <div className="flex-1 relative flex items-end justify-center">
                {/* Mobile Image */}
                <Image
                  src={getImageUrl("/vilvabusiness/website/mobile-img/container-4%20(mob).webp")}
                  alt="Analytics dashboard tracking visitors, leads, and customers"
                  width={350}
                  height={450}
                  quality={70}
                  className="block md:hidden w-full h-full object-cover"
                />

                {/* Desktop Image */}
                <Image
                  src={getImageUrl("/vilvabusiness/website/products/business-website/container4.webp")}
                  alt="Analytics dashboard tracking visitors, leads, and customers"
                  width={500}
                  height={600}
                  quality={75}
                  loading="lazy"
                  className="hidden md:block w-full h-full object-contain"
                />
              </div>
            </div>

            {/* Security, Compliance & Reliability Card */}
            <div className="rounded-2xl overflow-hidden bg-[#4A6FA1] p-6 md:p-8  flex flex-col relative">
              <div className="space-y-4 mb-8 relative z-10">
                <h2 className="font-NeueMontreal font-bold text-2xl leading-[120%] text-white">
                  Security, Compliance & Reliability
                </h2>
                <p className="font-Schibsted_Grotesk text-base leading-[150%] text-white">
                  Ensure long-term trust with secure data handling, compliance-ready infrastructure, and reliable systems designed to protect your business and customers at every step.
                </p>
              </div>

              <div className="flex-1 relative flex items-end justify-center">
                {/* Mobile Image */}
                <Image
                  src={getImageUrl("/vilvabusiness/website/mobile-img/container5%20-%20(mob).webp")}
                  alt="Secure, compliance-ready website infrastructure"
                  width={350}
                  height={450}
                  quality={70}
                  className="block md:hidden w-full h-full object-cover"
                />

                {/* Desktop Image */}
                <Image
                  src={getImageUrl("/vilvabusiness/website/products/business-website/container5.webp")}
                  alt="Secure, compliance-ready website infrastructure"
                  width={500}
                  height={600}
                  quality={75}
                  loading="lazy"
                  className="hidden md:block w-full h-full object-contain"
                />
              </div>
            </div>
          </div>
        </section>
      </div>

      {/* Why Teams Love Working With Us */}
      <div className="py-[60px] md:py-[100px] px-4 md:px-0 md:container">
        <h2 className="text-[#090D28] text-center text-[32px] md:text-[48px] leading-[120%] font-NeueMontreal">Why teams love{" "}
          <span className="text-[32px] md:text-[48px]  leading-[120%] font-NeueMontreal bg-gradient-to-r from-[#1586FF] to-[#003FDF] bg-clip-text text-transparent"
          >Working With Us</span> </h2>
        <p className="text-[#000]/70 text-center text-[16px] md:text-[18px] font-[400] leading-[150%] !font-Schibsted_Grotesk py-4">When our customers win, we win. Here’s how they’ve used our tools to succeed.</p>

        <section className="flex items-center justify-center gap-3">
          <Image
            src="/images/assets/Google-review.svg"
            width={220}
            height={220}
            alt="Google review tag"
            quality={75}
            className=""
            style={{ width: 'auto', height: 'auto' }}
          />
          <Image
            src="/images/assets/Just-dail.svg"
            width={220}
            height={220}
            alt="Justdial review tag"
            quality={75}
            className=""
            style={{ width: 'auto', height: 'auto' }}
          />
        </section>

        {/* Old testimonials hidden — unified to CircularTestimonialView */}
        {/* <section className="md:container px-[16px] pt-[20px] md:pt-[80px]">
          <Testimonials page="business-website" />
        </section> */}
        <section className="md:container px-[16px] pt-[20px] md:pt-[80px] flex justify-center items-center">
          <CircularTestimonialView page="business-website" />
        </section>
      </div>

      {/* Built for Businesses That Want */}
      <section className="py-[40px] lg:py-[88px] bg-[#E9F8FE]">
        <div className="max-w-7xl mx-auto px-0 ">
          {/* Heading */}
          <div className="">
            <h2 className="text-[36px] lg:text-[48px] font-[700] font-NeueMontreal text-[#090D28] leading-[120%] mb-4 lg:max-w-7xl mx-auto text-center">
              Built for Businesses That Want Growth,
              <br className="hidden sm:block space-y-6" />
              Not Just a Website
            </h2>

            <p className="text-[18px] pb-4 text-[#090D28]/80 max-w-7xl mx-auto leading-[150%] font-Schibsted_Grotesk text-center px-[16px]">
              Vilva is designed for companies that see their website as a sales and growth tool,
              not a digital visiting card.
            </p>
          </div>

          {/* Four Cards Grid */}
          <div className="w-full max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-5 md:gap-6 lg:gap-7 items-stretch">
            <div className="md:px-[16px] lg:px-0 px-[16px]">
              <div className="bg-[#D5F0FB] p-[24px] rounded-[16px] flex flex-col gap-[16px] h-full">
                <div className="flex items-start justify-start text-blue-600 text-3xl group-hover:bg-blue-200 transition-colors">
                  <Icons.Rocket />
                </div>
                <h3 className="text-[24px] font-bold text-gray-900 font-NeueMontreal">
                  Growing Businesses & Startups
                </h3>
                <p className="text-gray-700 leading-relaxed font-Schibsted_Grotesk">
                  For teams ready to turn website traffic into consistent leads. Built to support growth, not just visibility. Designed for scale through smart automation. Focused on measurable business outcomes.
                </p>
              </div>
            </div>


            <div className="md:px-[16px] lg:px-0 px-[16px] ">
              <div className="bg-[#D5F0FB] p-[24px] rounded-[16px] flex flex-col gap-[16px] h-full">
                <div className=" flex items-center justify-start text-purple-600 text-3xl group-hover:bg-purple-200 transition-colors">
                  <Icons.Services />
                </div>
                <h3 className="text-[24px] font-bold text-gray-900 font-NeueMontreal">
                  Service-Based Businesses
                </h3>
                <p className="text-gray-700 leading-relaxed font-Schibsted_Grotesk">
                  For enquiry-driven businesses that depend on inbound leads. Built to capture interest at the right moment. Designed for fast follow-ups and response. Helping teams close deals faster.
                </p>
              </div>
            </div>

            <div className="md:px-[16px] lg:px-0 px-[16px] ">
              <div className="bg-[#D5F0FB] p-[24px] rounded-[16px] flex flex-col gap-[16px] h-full">
                <div className=" flex items-center justify-start text-teal-600 text-3xl group-hover:bg-teal-200 transition-colors">
                  <Icons.Brand />
                </div>
                <h3 className="text-[24px] font-bold text-gray-900 font-NeueMontreal">
                  Retail, D2C & Multi-Outlet Brands
                </h3>
                <p className="text-gray-700 leading-relaxed font-Schibsted_Grotesk">
                  For brands that need high-speed, conversion-first websites. Built to turn traffic into real enquiries. Seamlessly connected to marketing and sales systems. Designed to support growth at scale.
                </p>
              </div>
            </div>

            <div className="md:px-[16px] lg:px-0 px-[16px] ">
              <div className="bg-[#D5F0FB] p-[24px] rounded-[16px] flex flex-col gap-[16px] h-full">
                <div className="flex items-center justify-start text-amber-600 text-3xl group-hover:bg-amber-200 transition-colors">
                  <Icons.Achieve />
                </div>
                <h3 className="text-[24px] font-bold text-gray-900 font-NeueMontreal">
                  Sales-Driven Teams & Founders
                </h3>
                <p className="text-gray-700 leading-relaxed font-Schibsted_Grotesk">
                  For founders and sales teams focused on lead quality. Built to improve response time and follow-ups. Designed to support faster decision-making. Measured by real ROI, not vanity metrics.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* We Make for Your Team */}
      <section className="bg-[#01001E]  py-[60px] relative overflow-hidden">
        <h4 className="text-white z-50 relative text-center text-[32px] md:text-[48px] font-extrabold leading-[120%] font-NeueMontreal">We Make for Your Team  </h4>
        <p className="text-[#c4c4c4] z-50 relative text-center text-[16px] md:text-[18px] font-normal leading-[150%] font-Schibsted_Grotesk py-4">Our team ensures timely results without compromising quality</p>

        <section className='flex items-center justify-center gap-3 '>
          <TestiReviewCommonImages />
          <div>
            <a
              href='https://maps.app.goo.gl/wxZr7ckDhrWnVbx27'
              className='text-[#090D28]'
              target='_blank'
            >
              {' '}
              <p className=' m-0 flex items-center gap-1 p-0 pb-[6px] text-center font-LatinkaRegular text-sm font-normal leading-[120%] text-white'>
                <Image className='w-6' src={getImageUrl("/vilvabusiness/website/common/homepage/google-img.webp")} width={50} height={50} quality={75} alt='GoogleImg' />{' '}
                Google Reviews
              </p>
            </a>
            <div className='flex items-center gap-2 text-white'>
              4.7
              <div className='flex items-center gap-2'>
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
                <SvgIcons.ReviewStar />
              </div>
            </div>
          </div>
        </section>
        <div className="relative z-50">
          <StatsSection />

        </div>
      </section>

      {/* FAQ Section */}
      <section className="pb-[60px] md:pb-[120px] px-4 md:px-0 md:container">
        {/* <h2 className="text-[#090D28] text-center md:text-[] text-[32px] w-full mx-auto whitespace-normal md:whitespace-nowrap md:text-[40px] font-extrabold leading-[120%] font-LatinkaBold">
          Your questions Our Answers
        </h2> */}
        <FaqSection faqs={faqs} />
      </section>
    </>
  );
};

export default BusinessWebsite;





